import React, { Fragment } from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import Field from '@common/components/validation/field.validation';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import FocusHelper from '@common/helpers/focus.helper';
import * as formatterUtils from '@common/helpers/formatter.utils';
import { StyledPhoneInputHeight } from './phone.style';
import PhoneHelper from '@common/helpers/phone.helper';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);

    this.predefinedMasks = formatterUtils.predefinedMasks;
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  getPlaceHolder() {
    let placeHolderPhone = this.predefinedMasks.telefone.placeHolder;

    return placeHolderPhone.replace(/#/g, 9).replace(/A/g, 'a').replace(/\*/g, '*').replace(/"/g, '');
  }

  renderComponent() {
    const { props } = this;
    const {
      Label,
      Tooltip,
      Obrigatorio,
      Desabilitado,
      Tamanho,
      TamanhoMinimo,
      name,
      onKeyDown,
      PlacementTooltip,
      isTelefoneExterior,
      specialLabel,
    } = props;

    return (
      <Field {...props}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <Fragment>
              {isTelefoneExterior ? (
                <LabeledInput {...props} name={name + ' Exterior'}>
                  <OverlayTrigger
                    key={`top-${name}=Exterior`}
                    placement={PlacementTooltip || 'top'}
                    overlay={
                      <TooltipBootstrap id={`tooltip-${name}-Exterior`}>
                        <div className={'fontTooltip'}>{Tooltip || Label}</div>
                      </TooltipBootstrap>
                    }
                  >
                    <StyledPhoneInputHeight
                      inputClass={`form-control ${hasError ? 'form-invalid' : ''}`}
                      value={value}
                      specialLabel={specialLabel ?? 'Phone'}
                      disabled={Desabilitado}
                      onBlur={onBlur}
                      country="br"
                      inputProps={{
                        name: name,
                        type: 'text',
                        required: Obrigatorio,
                        minLength: TamanhoMinimo,
                        maxLength: Tamanho,
                      }}
                      onChange={(value, data, event, formattedValue) =>
                        onChangeAsync(value, data, event, formattedValue)
                      }
                    />
                  </OverlayTrigger>
                </LabeledInput>
              ) : (
                <LabeledInput {...props}>
                  <OverlayTrigger
                    key={`top-${name}`}
                    placement={PlacementTooltip || 'top'}
                    overlay={
                      <TooltipBootstrap id={`tooltip-${name}`}>
                        <div className={'fontTooltip'}>{Tooltip || Label}</div>
                      </TooltipBootstrap>
                    }
                  >
                    <div className="input-group">
                      <input
                        className={`form-control ${hasError ? 'form-invalid' : ''}`}
                        name={name}
                        type={'text'}
                        value={PhoneHelper.returnFormattedValue(value) || ''}
                        disabled={Desabilitado}
                        required={Obrigatorio}
                        maxLength={Tamanho}
                        minLength={TamanhoMinimo}
                        onBlur={onBlur}
                        placeholder={this.getPlaceHolder()}
                        onKeyDown={onKeyDown}
                        onKeyUp={this.onKeyUp}
                        onChange={(e) => {
                          e.target.value = PhoneHelper.returnFormattedValue(e.target.value);
                          onChangeAsync(e);
                        }}
                      ></input>
                    </div>
                  </OverlayTrigger>
                </LabeledInput>
              )}
            </Fragment>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" readOnly>
                  {field.value || ''}
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{field.value || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
